<template>
  <div class="app-view-payment-data">
    <slot name="txtBefore">Zahlungsart</slot>
    <CreditCardInformation
      v-if="isCreditCard"
      :credit-card-information="paymentData"
    >
      <template v-for="slot in possibleChildSlotsFor('CreditCardInformation')"
                v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </CreditCardInformation>
    <BankAccountInformation
      v-if="isBankAccount"
      :bank-account="paymentData"
      :customer="customerInfo"
    >
      <template v-for="slot in possibleChildSlotsFor('BankAccountInformation')"
                v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </BankAccountInformation>
    <div class="no-payment-information" v-if="noPaymentData">
      <div class="no-payment-text" v-if="currentStep !== 'success'">
        <slot name="noPaymentTxt">
          Zahlung per Überweisung: Informationen zur Kontoverbindung erhälst du nach Abschluss
          deiner Bestellung.
        </slot>
      </div>
      <div class="no-payment-text" v-if="currentStep === 'success'">
        <b-row class="transfer-owner">
          <b-col cols="12" md=""><label><slot name="lblOwner"></slot></label></b-col>
          <b-col><slot name="valueOwner"></slot></b-col>
        </b-row>
        <b-row class="transfer-iban">
          <b-col cols="12" md=""><label><slot name="lblIban"></slot></label></b-col>
          <b-col><slot name="valueIban"></slot></b-col>
        </b-row>
        <b-row class="transfer-bic">
          <b-col cols="12" md=""><label><slot name="lblBic"></slot></label></b-col>
          <b-col><slot name="valueBic"></slot></b-col>
        </b-row>
        <b-row class="transfer-bank">
          <b-col cols="12" md=""><label><slot name="lblBank"></slot></label></b-col>
          <b-col><slot name="valueBank"></slot></b-col>
        </b-row>
        <b-row class="transfer-amount">
          <b-col cols="12" md=""><label><slot name="lblAmount"></slot></label></b-col>
          <b-col><slot name="valueAmount"><span class="transfer-value">{{sumCosts}}</span></slot></b-col>
        </b-row>
        <b-row class="transfer-usage">
          <b-col cols="12" md=""><label><slot name="lblUsage"></slot></label></b-col>
          <b-col><slot name="valueUsage"></slot><span class="transfer-value">{{contractId}}</span></b-col>
        </b-row>
      </div>
    </div>
    <div class="no-payment-information" v-if="isPaypal">
      <slot name="paypalTxtSuccess" v-if="currentStep === 'success'">
        Payppal-Zahlung erfolgt
      </slot>
      <slot name="paypalTxt" v-else>
        Paypal-Zahlung
      </slot>
    </div>
  </div>
</template>

<script>
import CreditCardInformation from '@/components/process/generic/Payment/CreditCardInformation.vue'
import BankAccountInformation from '@/components/process/generic/Payment/BankAccountInformation.vue'
import slotProxy from '@/mixins/slotProxy'
import { BCol, BRow } from 'bootstrap-vue'
import { mapGetters } from 'vuex'

export default {
  name: 'PaymentInformation',
  components: { BankAccountInformation, CreditCardInformation, BRow, BCol },
  computed: {
    ...mapGetters('orderProduct', [
      'getConfirmResponse'
    ]),
    ...mapGetters('orderProduct/product', [
      'getSumCosts'
    ]),
    ...mapGetters('orderProduct/payment', {
      paymentContext: 'paymentContext'
    }),
    isCreditCard () {
      return this.paymentData.type === 'creditCard'
    },
    isBankAccount () {
      return this.paymentData.type === 'bankAccount'
    },
    noPaymentData () {
      return this.paymentData === null || this.paymentData === '' || this.paymentData.paymentType === 'withoutPayment'
    },
    isPaypal () {
      return this.paymentData.type === 'paypal'
    },
    contractId () {
      if (this.getConfirmResponse.contractId !== null || this.getConfirmResponse.contractId === '') {
        return this.getConfirmResponse.contractId
      }
      return null
    },
    sumCosts () {
      return this.getSumCosts
    },
    customerInfo () {
      return this.paymentContext
    }
  },
  props: {
    paymentData: {
      type: Object
    },
    currentStep: {
      type: String
    }
  },
  mixins: [
    slotProxy()
  ]

}
</script>
